import {constants, mediaQueryStyles, typographyStyles as Typography} from '@newsela/angelou';
import {css, cx} from 'emotion';

const {BreakpointNames, mediaQuery} = mediaQueryStyles;

const angelouUI = constants.colors.ui;
const grey700 = angelouUI.grey[700];

const cleverBrandColor = '#416FE4';
const microsoftBrandColor = '#2F2F2F';
const white = angelouUI.white[500];

const linkLabel = cx([css`
  color: ${white};
  line-height: 16px;
  text-align: center;
  margin: auto;
  ${mediaQuery.upTo(BreakpointNames.sm)} {
    font-size: 14px;
  };
  `,
css(Typography.text2.styles),
]);

const cleverIcon = css`
  width: 32px;
  height: 32px;
  margin-left: 3px;
  margin-right: 40px;
  ${mediaQuery.downTo(BreakpointNames.sm)} {
    margin-right: 95px;
  };
`;

const googleIcon = css`
  width: 40px;
  height: 40px;
  margin-right: 35px;
  ${mediaQuery.downTo(BreakpointNames.sm)} {
    margin-right: 90px;
  };
`;

const googleLabel = cx([
  css(linkLabel),
  css`
    color: ${grey700};
  `,
]);

const microsoftIcon = css`
  width: 32px;
  height: 32px;
  margin-right: 35px;
  ${mediaQuery.downTo(BreakpointNames.sm)} {
    margin-right: 85px;
  };
`;

const socialLinkDescription = css`
  display: inline-flex;
`;

export default {
  linkLabel,
  cleverBrandColor,
  cleverIcon,
  googleIcon,
  googleLabel,
  microsoftBrandColor,
  microsoftIcon,
  socialLinkDescription,
  white,
};
